/**
 * 区别于 vue的 events 和 node 的 events，emit的时候不返回值，只会返回true, false
 */
export default class Events {
  constructor() {
    this._events = {}
  }

  // 如果要指定作用,请用 bind切换 this
  on(name, fn) {
    this._events[name] = fn
  }
  // 区别官方的emit, 只执行一次，并且返回结果
  emit(name, ...args) {
    return this._events[name](...args)
  }

  off(name) {
    if (this._events[name]) {
      delete this._events[name]
    }
  }
}



// WEBPACK FOOTER //
// ./src/libs/Events.js